<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  source: { type: Object, required: true },
});

const { t } = useI18n();
const email = computed(() => props.source.email || {});

const PRIORITY_CLASSES = {
  high: 'bg-n-ruby-3 text-n-ruby-11',
  urgent: 'bg-n-ruby-3 text-n-ruby-11',
  medium: 'bg-n-amber-3 text-n-amber-11',
  low: 'bg-n-alpha-2 text-n-slate-11',
};

const priorityLabel = computed(() => {
  if (!email.value.priority) return '';
  const key = `MULTICHAT.SOURCE.EMAIL.PRIORITIES.${email.value.priority.toUpperCase()}`;
  return t(key) === key ? email.value.priority : t(key);
});
</script>

<template>
  <div class="flex flex-wrap items-center gap-2">
    <span
      v-if="email.mailbox"
      class="inline-flex items-center gap-1.5 h-6 px-2 rounded-md bg-n-alpha-2 text-xs text-n-slate-12"
    >
      <span class="i-lucide-inbox size-3.5 text-n-slate-10" />
      <span class="font-mono">{{ email.mailbox }}</span>
    </span>
    <span
      v-if="email.category"
      class="inline-flex items-center gap-1 h-6 px-2 rounded-md bg-n-blue-3 text-n-blue-11 text-xs font-medium"
    >
      <span class="i-lucide-folder size-3.5" />
      {{ email.category }}
    </span>
    <span
      v-if="priorityLabel"
      class="inline-flex items-center gap-1 h-6 px-2 rounded-md text-xs font-medium"
      :class="
        PRIORITY_CLASSES[email.priority] || 'bg-n-alpha-2 text-n-slate-11'
      "
    >
      <span class="i-lucide-flag size-3.5" />
      {{ priorityLabel }}
    </span>
  </div>
</template>
